module.exports = __webpack_public_path__ + "static/media/cloud.030ad1fa.jpg";